import type { TColor } from '@revert/color'

export const COLOR_BLACK: TColor = 0x000000FF
export const COLOR_WHITE: TColor = 0xFFFFFFFF
export const COLOR_TRANSPARENT: TColor = 0x0
